module.exports = __webpack_public_path__ + "assets/img/70x_519_1.d0513d63.jpg";